import debug from 'debug'

import PubSub from 'pubsub-js'

const log = debug('behaviour:button:summary-change')

log('`behaviour` is awake')

export default function handleClick () {
  log('handleClick')

  PubSub.publish('summary:change')
}
